import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { getCityStateAndZipcode, getStreetAddress } from 'common/source/utilities/policyInfoDisplay';

const module = angular.module('overview-page-header', []);

interface OverviewPageHeaderController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    streetAddress: string;
    cityStateAndZipCode: string;
}

module.component('overviewPageHeader', {
    bindings: {
        policyInfo: '<'
    },
    template: template,
    controller: function(this: OverviewPageHeaderController) {
        this.$onInit = function() {
            this.cityStateAndZipCode = getCityStateAndZipcode(this.policyInfo);
            this.streetAddress = getStreetAddress(this.policyInfo);
        };
    }
});

export { module };
